module.exports = __webpack_public_path__ + "static/img/son2.604ebb45.png";